import { render } from "./RpcBlog.vue?vue&type=template&id=124b4e0e&scoped=true"
import script from "./RpcBlog.vue?vue&type=script&lang=js"
export * from "./RpcBlog.vue?vue&type=script&lang=js"

import "./RpcBlog.vue?vue&type=style&index=0&id=124b4e0e&lang=scss&scoped=true"

import exportComponent from "/Applications/CODE/mickwebsite/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124b4e0e"]])

export default __exports__